import { AUTH_TOKEN, ACCESS_TOKEN_TTL } from "../constants/constants";
import { decodeJwt } from "jose";

export function getJwt() {
  //return localStorage.getItem(ACCESS_TOKEN) ?? null
  return getCookie(AUTH_TOKEN) ?? null;
}

export function isJWTExpired() {
  let decodedJWT;
  const token = getJwt();
  if (token) {
    try {
      decodedJWT = decodeJwt(token);
      if (decodedJWT) {
        if (decodedJWT.exp && decodedJWT.exp * 1000 >= new Date().getTime()) {
          console.log("token** not exp");
          return false;
        } else {
          console.log("token** exp");
          return true;
        }
      }
    } catch (error) {
      console.log("token** exp", error);
      return true;
    }
  }
  console.log("token** exp");
  return true;
}

export function getIDFromToken() {
  let decodedJWT;
  const token = getJwt();
  if (token) {
    decodedJWT = decodeJwt(token);
  }
  return decodedJWT?.sub ?? null;
}

export function getTenantIDFromToken(token) {
  let decodedJWT;
  if (token) {
    decodedJWT = decodeJwt(token);
  }
  return decodedJWT?.tenant ?? null;
}

export function setCookie(name, value, minutes = ACCESS_TOKEN_TTL) {
  let expires = "";
  const date = new Date();
  date.setTime(date.getTime() + minutes * 60 * 1000);
  expires = "; expires=" + date.toUTCString();
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
export function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function deleteCookie(name) {
  setCookie(name, "", -1);
}

export function listenForCookieChange(cookieName, onChange) {
  // If the cookieStore is available, we can can use the change event listener
  if ("cookieStore" in window) {
    const changeListener = (event) => {
      const foundCookie = event.changed.find(
        (cookie) => cookie.name === cookieName,
      );
      if (foundCookie) {
        onChange(foundCookie.value);
        return;
      }

      const deletedCookie = event.deleted.find(
        (cookie) => cookie.name === cookieName,
      );
      if (deletedCookie) {
        onChange(null);
      }
    };

    window.cookieStore.addEventListener("change", changeListener);

    // We return a clean up function for the effect
    return () => {
      window.cookieStore.removeEventListener("change", changeListener);
    };
  }

  // If cookieStore is not available, we poll for changes.
  let previousValue = getCookie(cookieName);
  const interval = setInterval(() => {
    const cookie = getCookie(cookieName);
    const currentValue = cookie ?? null;
    if (currentValue !== previousValue) {
      previousValue = currentValue;
      onChange(currentValue);
    }
  }, 1000);

  // We still return a clean up function for the effect
  return () => {
    clearInterval(interval);
  };
}
